import type { MeasureReducerAction } from "./measureReducer";


const setMeasureState = (
    obj: { measuring: boolean, measureStart: { x: number, y: number }},
): MeasureReducerAction => {
    return {
        type: 'MEASURE/SET_STATE',
        ...obj,
    };
};


export {
    setMeasureState,
};
